<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  totalPages: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  maxVisible: {
    type: Number,
    default: 5, // Número máximo de páginas visibles
  },
  onChangePage: {
    type: Function,
    required: true,
  },
});

// Genera el rango de páginas visibles
const visiblePages = computed(() => {
  const range = [];
  const start = Math.max(1, props.currentPage - Math.floor(props.maxVisible / 2));
  const end = Math.min(props.totalPages, start + props.maxVisible - 1);

  for (let i = start; i <= end; i++) {
    range.push(i);
  }

  return range;
});
</script>

<template>
  <div class="flex items-center justify-center space-x-2 mt-4" v-if="totalPages > 1">
    <!-- Botón de página anterior -->
    <button
        class="flex items-center justify-center px-2 py-1 rounded-md bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:pointer-events-none"
        :disabled="props.currentPage === 1"
        @click="props.onChangePage(props.currentPage - 1)"
    >
      <span class="material-icons">chevron_left</span>
    </button>

    <!-- Números de página -->
    <div class="flex space-x-1">
      <button
          v-for="page in visiblePages"
          :key="page"
          @click="props.onChangePage(page)"
          class="px-2 py-1 rounded-md text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-yellow-500 hover:text-black dark:hover:bg-yellow-500 dark:hover:text-black"
          :class="{
          'bg-yellow-500 text-black dark:bg-yellow-500 dark:text-black': page === props.currentPage
        }"
      >
        {{ page }}
      </button>
    </div>

    <!-- Botón de página siguiente -->
    <button
        class="flex items-center justify-center px-2 py-1 rounded-md bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:pointer-events-none"
        :disabled="props.currentPage === props.totalPages"
        @click="props.onChangePage(props.currentPage + 1)"
    >
      <span class="material-icons">chevron_right</span>
    </button>
  </div>
</template>

<style scoped>
/* Adicional para estilos personalizados si es necesario */
</style>
